import './App.css'
import ControlsGuide from './components/ui/ControlsGuide'
import Stage from './components/Stage'
import AnalogControl from './components/ui/AnalogControl'
import GestureRecognition from './components/Gesture/'

function App() {
  const isTouchScreenDevice = () => {
    try {
      document.createEvent('TouchEvent')
      return true
    } catch (e) {
      return false
    }
  }

  return (
    <div className="App">
      <Stage />
      {isTouchScreenDevice() ? (
        <AnalogControl />
      ) : (
        <>
          <ControlsGuide />
          <GestureRecognition />
        </>
      )}
    </div>
  )
}

export default App
